export const mockData = {
  about: {
    description: "Feronex Global is a leading scrap metal import company specializing in bringing premium quality stainless steel and other metals from UK and Europe to India. We serve the smelting and metal processing industry with reliable supply chains and exceptional service.",
    highlights: [
      {
        icon: "globe",
        title: "International Network",
        description: "Strong partnerships with suppliers across UK and Europe ensuring consistent quality and supply."
      },
      {
        icon: "award",
        title: "Quality Assurance",
        description: "Rigorous quality checks and certifications to meet industry standards for all metal grades."
      },
      {
        icon: "shield",
        title: "Reliable Delivery",
        description: "Expert shipping and logistics management ensuring timely delivery across India."
      }
    ]
  },
  
  services: [
    {
      icon: "ship",
      title: "International Shipping Expertise",
      description: "End-to-end shipping solutions from UK and Europe to Indian ports with full documentation support.",
      features: [
        "Container and bulk cargo handling",
        "Customs clearance assistance",
        "Port-to-door delivery options",
        "Real-time shipment tracking"
      ]
    },
    {
      icon: "globe",
      title: "Global Sourcing",
      description: "Access to premium scrap metal suppliers across UK and European markets.",
      features: [
        "Verified supplier network",
        "Quality inspection at source",
        "Competitive pricing",
        "Multiple material grades"
      ]
    },
    {
      icon: "zap",
      title: "Fast Processing",
      description: "Streamlined import process to ensure quick turnaround times for your orders.",
      features: [
        "Efficient documentation",
        "Quick order processing",
        "Flexible payment terms",
        "Regular shipment schedules"
      ]
    },
    {
      icon: "shield",
      title: "Quality Guarantee",
      description: "Comprehensive quality assurance and material certification for all shipments.",
      features: [
        "Material testing reports",
        "Grade certifications",
        "Compliance documentation",
        "Post-delivery support"
      ]
    }
  ],
  
  products: [
    {
      name: "Stainless Steel Scrap",
      description: "Premium quality stainless steel scrap in various grades including 300, 400, and 200 series.",
      grades: ["SS304", "SS316", "SS321", "SS430", "SS201"],
      image: "https://images.pexels.com/photos/5279399/pexels-photo-5279399.jpeg",
      gradeTable: {
        "300 Series": ["304", "316", "303", "321"],
        "400 Series": ["430", "410", "440C"],
        "200 Series": ["201"]
      }
    },
    {
      name: "Aluminium Scrap",
      description: "High-grade aluminium scrap including 6063 and other alloys for industrial applications.",
      grades: ["6063", "6061", "Alloy", "Pure Aluminium"],
      image: "https://images.pexels.com/photos/6591428/pexels-photo-6591428.jpeg"
    },
    {
      name: "MS (Mild Steel) Alloys",
      description: "Premium mild steel alloys and busheling scrap for smelting operations.",
      grades: ["MS Alloys", "MS Busheling", "Steel Scrap", "Iron Scrap"],
      image: "https://images.pexels.com/photos/5846145/pexels-photo-5846145.jpeg"
    },
    {
      name: "Alternators & Motors",
      description: "Electric alternator and motor scrap containing valuable metals for recycling.",
      grades: ["Alternators", "Electric Motors", "Motor Scrap"],
      image: "https://images.pexels.com/photos/20423571/pexels-photo-20423571.jpeg"
    },
    {
      name: "Magnesium Material",
      description: "High-purity magnesium scrap and materials for industrial metal processing.",
      grades: ["Pure Magnesium", "Magnesium Alloys"],
      image: "https://images.pexels.com/photos/3361230/pexels-photo-3361230.jpeg"
    },
    {
      name: "Other Metals",
      description: "Wide range of ferrous and non-ferrous metals including copper, brass, zinc and more.",
      grades: ["Copper Wire", "Brass", "Zinc", "Bronze", "Lead"],
      image: "https://images.pexels.com/photos/6591428/pexels-photo-6591428.jpeg"
    }
  ],
  
  supplyNetwork: [
    { value: "50+", label: "Cities Covered" },
    { value: "200+", label: "Industry Partners" },
    { value: "10,000+", label: "Tons Delivered Annually" }
  ],
  
  whyChooseUs: [
    {
      title: "Competitive Pricing",
      description: "Direct sourcing from Europe ensures best market rates for quality materials."
    },
    {
      title: "Quality Materials",
      description: "Certified and tested materials meeting international standards."
    },
    {
      title: "Reliable Supply",
      description: "Consistent supply chain with regular shipments and inventory management."
    },
    {
      title: "Expert Team",
      description: "Experienced professionals handling all aspects of import and logistics."
    },
    {
      title: "Pan-India Delivery",
      description: "Comprehensive distribution network covering major industrial centers."
    },
    {
      title: "Documentation Support",
      description: "Complete assistance with customs, permits, and compliance requirements."
    },
    {
      title: "Flexible Terms",
      description: "Customized payment and delivery options to suit your business needs."
    },
    {
      title: "After-Sales Service",
      description: "Dedicated support team for queries and ongoing business requirements."
    }
  ],
  
  gallery: [
    {
      url: "https://customer-assets.emergentagent.com/job_metalbridge-1/artifacts/q8fbybc4_WhatsApp%20Image%202026-01-30%20at%204.59.00%20AM.jpeg",
      title: "Stainless Steel Scrap Bales - SS304",
      category: "Products"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_metalbridge-1/artifacts/7qtw6om3_WhatsApp%20Image%202026-01-31%20at%204.53.09%20AM%20%281%29.jpeg",
      title: "Metal Scrap Bales - Compressed",
      category: "Products"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_metalbridge-1/artifacts/wfdp7e47_WhatsApp%20Image%202026-01-31%20at%204.53.09%20AM.jpeg",
      title: "Industrial Metal Scrap Bales",
      category: "Products"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_metalbridge-1/artifacts/ac0brwhd_WhatsApp%20Image%202026-01-31%20at%204.53.10%20AM.jpeg",
      title: "Mixed Metal Scrap - Ready for Export",
      category: "Products"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_metalbridge-1/artifacts/t5e7um5h_1.jpg",
      title: "Stainless Steel Sheets Bundle",
      category: "Products"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_metalbridge-1/artifacts/p2at07h9_3.jpg",
      title: "Premium Stainless Steel Sheets - Sorted",
      category: "Products"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_metalbridge-1/artifacts/0o5lfyun_4.jpg",
      title: "Steel Scrap Offcuts & Materials",
      category: "Products"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_metalbridge-1/artifacts/dfejn0vh_6.jpg",
      title: "Bundled Steel Sheets - Quality Grade",
      category: "Products"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_metalbridge-1/artifacts/xso1xobc_Image%202026-01-26%20at%207.30.54%20PM.jpeg",
      title: "Metal Scrap Pieces - Various Grades",
      category: "Products"
    }
  ]
};
